export const LANDING_PAGE_URL = "https://factu.mx";

//Initialize constants with environment settings
const CONSTANTS = {
  LOCAL: process.env.REACT_APP_ENV === "local",
  DEV: process.env.REACT_APP_ENV === "dev",
  PROD: process.env.REACT_APP_ENV === "prod",
};

CONSTANTS.API_BASE_URL = CONSTANTS.PROD
  ? "https://api.factu.mx"
  : "https://api.dev.factu.mx";

CONSTANTS.STRIPE_API_PK = CONSTANTS.PROD
  ? "pk_live_51PJ1RPGGL9CZep4MgTvnk6bFVdOIU3uhbukWWMAK6Sypd4ydFBpEQJ9XbErTYEP7XQbLEr9k2YXRR0l60qDCBXAA00bhiaamAD"
  : "pk_test_51PJ1RPGGL9CZep4Mc6LQPDLBv1ve1z9nYAkLbwTpLWRbzg9dmowvHZC3kMeeEqB85dIvPDUduk9NFg4qZPPlkLOx00PItWIUPM";

CONSTANTS.SAT_EFOS_INFO_URL =
  "https://www.sat.gob.mx/minisitio/Factura/documentos/infografias/operacionessimuladas.pdf";

CONSTANTS.API_RESPONSE_ERROR_SESSION_EXPIRED = "ERROR_SESSION_EXPIRED";

export default CONSTANTS;
